<template>
  <div ref="backTop" id="GoTop" @click="GoTop()" v-show="scrollTop > 800">
    <img src="../../static/image/backTop.png" />
    <p>{{ $t('lang.gotop.d') }}</p>
    <p>{{ $t('lang.gotop.b') }}</p>
  </div>
</template>
<script>
export default {
  name: 'GoTop',
  data () {
    return {
      flag: false,
      scrollTop: ''
    }
  },
  mounted () {
    this.scrollTop = window.pageYOffset
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    GoTop () {
      ;(function smoothscroll () {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll)
          window.scrollTo(0, currentScroll - currentScroll / 10)
        }
      })()
    },
    handleScroll () {
      this.scrollTop = window.pageYOffset // 滚动距离
    }
  }
}
</script>
<style scoped>
#GoTop {
  position: fixed;
  bottom: 42px;
  right: 105px;
  width: 40px;
  padding: 12px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 2px 17px 3px rgba(15, 36, 81, 0.1);
  border-radius: 20px;
  z-index: 999999;
  cursor: pointer;
  font-size: 14px;
  color: #0f2451;
  font-weight: 400;
}
#GoTop img {
  width: 15px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/common/GoTop.vue